import { PublicComponents } from '../../openapi/openapi';

const SZ_FRONT_LEFT_PNG= 'front-left.png' as string;
const SZ_BACK_HANDLE_PNG = 'back-handle.png' as string;
const SZ_BACK_VIEW_1 = 'BACK-VIEW-1' as const;

export interface PictureAcquisitionStep {
  category?: string;
  name: string;
  instruction?: {
    firstPicture: string;
    secondPicture: string;
  };
  guidanceImage?: string;
  view: PublicComponents.TabletView
}

export enum PictureAcquisitionStatus {
  STOP = 'STOP',
  IN_PROGRESS = 'IN_PROGRESS',
  PAUSE = 'PAUSE',
  PREVIEW = 'PREVIEW',
  FINISH = 'FINISH',
}

export interface CapturedImage {
  category?: string;
  name: string;
  timestamp: string;
  image: string;
  view: PublicComponents.TabletView
}

export const defaultPictureAcquisitionSteps: Record<number, PictureAcquisitionStep[]> = {
  2: [
    {
      category: 'FRONT',
      name: 'HANDLE-FRONT',
      guidanceImage: 'front-handle.png',
      view: 'FRONT-VIEW-1',
    },
    {
      category: 'BACK',
      name: 'HANDLE-BACK',
      instruction: {
        firstPicture: 'front-handle.png',
        secondPicture: SZ_BACK_HANDLE_PNG,
      },
      guidanceImage: SZ_BACK_HANDLE_PNG,
      view: SZ_BACK_VIEW_1,
    },
  ],
  4: [
    {
      category: 'FRONT',
      name: 'HANDLE-FRONT',
      view: 'FRONT-VIEW-1',
      guidanceImage: 'front-handle.png',
    },
    {
      category: 'FRONT',
      name: 'LEFT-FRONT',
      guidanceImage: SZ_FRONT_LEFT_PNG,
      view: 'FRONT-VIEW-2',
    },
    {
      category: 'BACK',
      name: 'HANDLE-BACK',
      instruction: {
        firstPicture: 'front-left.png',
        secondPicture: SZ_BACK_HANDLE_PNG,
      },
      guidanceImage: SZ_BACK_HANDLE_PNG,
      view: SZ_BACK_VIEW_1,
    },
    {
      category: 'BACK',
      name: 'RIGHT-BACK',
      guidanceImage: 'back-right.png',
      view: 'BACK-VIEW-2',
    },
  ],
  8: [
    {
      category: 'FRONT',
      name: 'HANDLE-FRONT',
      guidanceImage: 'front-handle.png',
      view: 'FRONT-VIEW-1',
    },
    {
      category: 'FRONT',
      name: 'LEFT-FRONT',
      guidanceImage: SZ_FRONT_LEFT_PNG,
      view: 'FRONT-VIEW-2',
    },
    {
      category: 'FRONT',
      name: 'BASE-FRONT',
      guidanceImage: 'front-rear.png',
      view: 'FRONT-VIEW-3',
    },
    {
      category: 'FRONT',
      name: 'RIGHT-FRONT',
      guidanceImage: 'front-right.png',
      view: 'FRONT-VIEW-4',
    },
    {
      category: 'BACK',
      name: 'HANDLE-BACK',
      instruction: {
        firstPicture: 'front-right.png',
        secondPicture: SZ_BACK_HANDLE_PNG,
      },
      guidanceImage: SZ_BACK_HANDLE_PNG,
      view: SZ_BACK_VIEW_1,
    },
    {
      category: 'BACK',
      name: 'RIGHT-BACK',
      guidanceImage: 'back-right.png',
      view: 'BACK-VIEW-2',
    },
    {
      category: 'BACK',
      name: 'BASE-BACK',
      guidanceImage: 'back-base.png',
      view: 'BACK-VIEW-3',
    },
    {
      category: 'BACK',
      name: 'LEFT-BACK',
      guidanceImage: 'back-left.png',
      view: 'BACK-VIEW-4',
    },
  ],
};
